import { store } from "../store/Store";
import AppConstants from "./Constants";
import { saveUserProfile } from "./Helpers";
import Storage from "./storage/StorageFunctions";

const CheckSession = async () => {
  const tokenLS = await Storage.getData(
    AppConstants.LocalStoreConstant.ACCESS_TOKEN
  );
  if (typeof tokenLS === "undefined") {
    await Storage.clearAll();
    return false;
  } else {
    const userDetails = store.getState()?.userReducer;
    if (
      userDetails.id == -1 ||
      userDetails.id === null ||
      userDetails.is_active === false
    ) {
      saveUserProfile(tokenLS);
    }
    return true;
  }
};

export default CheckSession;
